//  Storage keys  prefijo cp_ para no colisionar con el admin 
export const CP_TOKEN_KEY   = 'cp_access_token';
export const CP_REFRESH_KEY = 'cp_refresh_token';
export const CP_USER_KEY    = 'cp_user';
export const CP_ID_KEY      = 'cp_cliente_id';

export function limpiarSesionCliente() {
  localStorage.removeItem(CP_TOKEN_KEY);
  localStorage.removeItem(CP_REFRESH_KEY);
  localStorage.removeItem(CP_USER_KEY);
  localStorage.removeItem(CP_ID_KEY);
}

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:3000';

// ── Decodificar payload JWT sin verificar firma ──
function decodeJwtPayload(token) {
  try {
    const parts = token.split('.');
    if (parts.length !== 3) return { error: 'No es JWT válido (no tiene 3 partes)' };
    const payload = JSON.parse(atob(parts[1].replace(/-/g, '+').replace(/_/g, '/')));
    return payload;
  } catch (e) {
    return { error: 'No se pudo decodificar: ' + e.message };
  }
}

function getToken() {
  const t = localStorage.getItem(CP_TOKEN_KEY);
  if (!t || t === 'undefined' || t === 'null') return null;
  return t;
}

// ── Verificar si el token está expirado o a punto de expirar ──
function isTokenExpired(token, marginSec = 5) {
  if (!token) return true;
  const payload = decodeJwtPayload(token);
  if (!payload || payload.error || !payload.exp) return false; // si no se puede decodificar, dejar que el servidor decida
  const nowSec = Math.floor(Date.now() / 1000);
  return nowSec >= payload.exp - marginSec;
}

// ── Diagnóstico: ejecutar en consola del navegador: __cashsolDiag() ──
window.__cashsolDiag = function () {
  const token = localStorage.getItem(CP_TOKEN_KEY);
  const refresh = localStorage.getItem(CP_REFRESH_KEY);
  const user = localStorage.getItem(CP_USER_KEY);
  const id = localStorage.getItem(CP_ID_KEY);
  console.log('═══════════════════════════════════════════');
  console.log('  CASH SOL — DIAGNÓSTICO DE SESIÓN');
  console.log('═══════════════════════════════════════════');
  console.log('API_URL:', API_URL);
  console.log('cp_access_token:', token ? token.substring(0, 50) + '...' : 'NO HAY');
  console.log('cp_refresh_token:', refresh || 'NO HAY');
  console.log('cp_user:', user);
  console.log('cp_cliente_id:', id);
  if (token) {
    const payload = decodeJwtPayload(token);
    console.log('JWT PAYLOAD:', JSON.stringify(payload, null, 2));
    if (payload.exp) {
      const exp = new Date(payload.exp * 1000);
      const now = new Date();
      console.log('JWT EXPIRA:', exp.toISOString());
      console.log('AHORA:', now.toISOString());
      console.log('EXPIRADO:', now > exp ? 'SÍ ❌' : 'NO ✅');
    }
  }
  console.log('═══════════════════════════════════════════');
  // También hacer una petición de prueba
  console.log('Haciendo petición de prueba a /portal-cliente/perfil...');
  fetch(API_URL + '/portal-cliente/perfil', {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      ...(token ? { 'Authorization': 'Bearer ' + token } : {}),
    },
  })
    .then(r => {
      console.log('Respuesta status:', r.status);
      console.log('Respuesta headers:', Object.fromEntries(r.headers.entries()));
      return r.text();
    })
    .then(body => {
      console.log('Respuesta body:', body);
    })
    .catch(e => console.log('Error de red:', e.message));
};

//  Intento de refresh de token (si el backend lo soporta) 
let _refreshing = false;
let _refreshQueue = [];

async function tryRefresh() {
  const refreshToken = localStorage.getItem(CP_REFRESH_KEY);
  if (!refreshToken || refreshToken === 'undefined') return null;

  const res = await fetch(`${API_URL}/portal-cliente/refresh`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ refreshToken }),
  });

  if (!res.ok) return null;

  const data = await res.json();
  const newToken = data.accessToken || data.access_token || data.token;
  if (!newToken) return null;

  localStorage.setItem(CP_TOKEN_KEY, newToken);
  const newRefresh = data.refreshToken || data.refresh_token;
  if (newRefresh) localStorage.setItem(CP_REFRESH_KEY, newRefresh);
  return newToken;
}

//  Fetch wrapper con retry automatico en 401 
async function request(path, options = {}, _retry = false) {
  let token = getToken();

  // ── Proactivo: si el token ya expiró, intentar refrescar ANTES de la petición ──
  if (token && isTokenExpired(token) && !_retry) {
    const refreshToken = localStorage.getItem(CP_REFRESH_KEY);
    if (refreshToken && refreshToken !== 'undefined') {
      if (!_refreshing) {
        _refreshing = true;
        try {
          const newToken = await tryRefresh();
          if (newToken) {
            token = newToken;
            _refreshQueue.forEach((r) => r());
            _refreshQueue = [];
          } else {
            // Refresh falló — sesión expirada
            limpiarSesionCliente();
            window.dispatchEvent(new Event('cp:session-expired'));
            throw new Error('Sesión expirada. Por favor, inicia sesión nuevamente.');
          }
        } catch (e) {
          limpiarSesionCliente();
          window.dispatchEvent(new Event('cp:session-expired'));
          throw new Error('Sesión expirada. Por favor, inicia sesión nuevamente.');
        } finally {
          _refreshing = false;
        }
      } else {
        // Otro request ya está refrescando, esperar
        await new Promise((resolve) => _refreshQueue.push(resolve));
        token = getToken();
      }
    } else {
      // No hay refresh token y el access token expiró → cerrar sesión
      limpiarSesionCliente();
      window.dispatchEvent(new Event('cp:session-expired'));
      throw new Error('Sesión expirada. Por favor, inicia sesión nuevamente.');
    }
  }

  const headers = {
    'Content-Type': 'application/json',
    ...(token ? { Authorization: `Bearer ${token}` } : {}),
    ...(options.headers || {}),
  };

  const res = await fetch(`${API_URL}${path}`, { ...options, headers });

  // 401: intentar renovar token (respaldo por si el chequeo proactivo no fue suficiente)
  if (res.status === 401 && !_retry) {
    const refreshTk = localStorage.getItem(CP_REFRESH_KEY);
    if (refreshTk && refreshTk !== 'undefined') {
      if (_refreshing) {
        await new Promise((resolve) => _refreshQueue.push(resolve));
        return request(path, options, true);
      }
      _refreshing = true;
      try {
        const newToken = await tryRefresh();
        if (newToken) {
          _refreshQueue.forEach((r) => r());
          _refreshQueue = [];
          return request(path, options, true);
        }
      } catch { /* refresh falló */ }
      finally { _refreshing = false; }
    }
    // Sin refresh token o refresh falló — sesión expirada
    limpiarSesionCliente();
    window.dispatchEvent(new Event('cp:session-expired'));
    const err401 = new Error('Sesión expirada. Por favor, inicia sesión nuevamente.');
    err401.status = 401;
    throw err401;
  }

  let data;
  try { data = await res.json(); }
  catch {
    const raw = await res.text().catch(() => '');
    console.error('[API] Respuesta no-JSON del servidor:', res.status, raw);
    data = { message: `Error al procesar respuesta del servidor. (HTTP ${res.status})`, raw };
  }

  if (!res.ok) {
    const err = new Error(data?.message || 'Error del servidor');
    err.status = res.status;
    err.data = data;
    throw err;
  }

  return data;
}

// ── Fetch público (sin token, sin chequeo de expiración) ──
async function publicRequest(path, options = {}) {
  const headers = {
    'Content-Type': 'application/json',
    ...(options.headers || {}),
  };
  const res = await fetch(`${API_URL}${path}`, { ...options, headers });
  let data;
  try { data = await res.json(); }
  catch {
    const raw = await res.text().catch(() => '');
    console.error('[API] Respuesta no-JSON del servidor:', res.status, raw);
    data = { message: `Error al procesar respuesta del servidor. (HTTP ${res.status})`, raw };
  }
  if (!res.ok) {
    const err = new Error(data?.message || 'Error del servidor');
    err.status = res.status;
    err.data = data;
    throw err;
  }
  return data;
}

//  AUTH 
export const authApi = {
  login: (body) =>
    publicRequest('/portal-cliente/login', { method: 'POST', body: JSON.stringify(body) }),

  registrar: (body) =>
    publicRequest('/portal-cliente/registrar', { method: 'POST', body: JSON.stringify(body) }),

  recuperarPassword: (email) =>
    publicRequest('/portal-cliente/recuperar-password', {
      method: 'POST',
      body: JSON.stringify({ email }),
    }),

  resetPassword: (token, nueva_password) =>
    publicRequest('/portal-cliente/reset-password', {
      method: 'POST',
      body: JSON.stringify({ token, nueva_password }),
    }),

  logout: () =>
    request('/portal-cliente/logout', { method: 'POST' }),
};

//  INFO CREDITO (público) 
export const infoApi = {
  getInfoCredito: (tipo_credito_id = 1, detalle_tipo_credito_id = 9) =>
    publicRequest(
      `/portal-cliente/info-credito?tipo_credito_id=${tipo_credito_id}&detalle_tipo_credito_id=${detalle_tipo_credito_id}`
    ),
};

//  PERFIL 
export const perfilApi = {
  getPerfil: () => request('/portal-cliente/perfil'),

  updatePerfil: (body) =>
    request('/portal-cliente/perfil', { method: 'PUT', body: JSON.stringify(body) }),

  cambiarPassword: (body) =>
    request('/portal-cliente/cambiar-password', { method: 'PUT', body: JSON.stringify(body) }),
};

//  SOLICITUDES 
export const solicitudApi = {
  getMisSolicitudes: (page = 1, limit = 10) =>
    request(`/portal-cliente/mis-solicitudes?page=${page}&limit=${limit}`),

  getSolicitud: (id) => request(`/portal-cliente/mis-solicitudes/${id}`),

  solicitarCredito: (body) =>
    request('/portal-cliente/solicitar-credito', { method: 'POST', body: JSON.stringify(body) }),
};

//  EVIDENCIAS — subir archivos, devuelve { urls: string[] } 

// Comprime una imagen via Canvas. Si el archivo no es imagen, lo devuelve tal cual.
// maxW/maxH: dimensión máxima. quality: 0-1 para JPEG.
async function comprimirImagen(file, maxW = 1280, maxH = 1280, quality = 0.75) {
  if (!file.type.startsWith('image/')) return file; // PDFs u otros: sin comprimir
  return new Promise((resolve) => {
    const img = new Image();
    const url = URL.createObjectURL(file);
    img.onload = () => {
      URL.revokeObjectURL(url);
      let { width, height } = img;
      if (width > maxW || height > maxH) {
        const ratio = Math.min(maxW / width, maxH / height);
        width  = Math.round(width  * ratio);
        height = Math.round(height * ratio);
      }
      const canvas = document.createElement('canvas');
      canvas.width  = width;
      canvas.height = height;
      canvas.getContext('2d').drawImage(img, 0, 0, width, height);
      canvas.toBlob(
        (blob) => {
          if (!blob) { resolve(file); return; }
          // Si la compresión aumentó el tamaño, usar el original
          if (blob.size >= file.size) { resolve(file); return; }
          resolve(new File([blob], file.name, { type: 'image/jpeg', lastModified: Date.now() }));
        },
        'image/jpeg',
        quality
      );
    };
    img.onerror = () => { URL.revokeObjectURL(url); resolve(file); };
    img.src = url;
  });
}

export const evidenciaApi = {
  upload: async (files, _retry = false) => {
    let token = getToken();

    // Refresh proactivo si el token está expirado (igual que request())
    if (token && isTokenExpired(token) && !_retry) {
      const refreshTk = localStorage.getItem(CP_REFRESH_KEY);
      if (refreshTk && refreshTk !== 'undefined') {
        if (!_refreshing) {
          _refreshing = true;
          try {
            const newToken = await tryRefresh();
            if (newToken) {
              token = newToken;
              _refreshQueue.forEach((r) => r());
              _refreshQueue = [];
            } else {
              limpiarSesionCliente();
              window.dispatchEvent(new Event('cp:session-expired'));
              throw new Error('Sesión expirada. Por favor, inicia sesión nuevamente.');
            }
          } finally {
            _refreshing = false;
          }
        } else {
          await new Promise((resolve) => _refreshQueue.push(resolve));
          token = getToken();
        }
      } else {
        limpiarSesionCliente();
        window.dispatchEvent(new Event('cp:session-expired'));
        throw new Error('Sesión expirada. Por favor, inicia sesión nuevamente.');
      }
    }

    // Comprimir imágenes antes de subir (evita 413)
    const filesComprimidos = await Promise.all(files.map((f) => comprimirImagen(f)));

    const formData = new FormData();
    filesComprimidos.forEach((f) => formData.append('files', f));

    const res = await fetch(`${API_URL}/portal-cliente/evidencias/upload`, {
      method: 'POST',
      headers: token ? { Authorization: `Bearer ${token}` } : {},
      body: formData,
    });

    // Retry automático en 401 (igual que request())
    if (res.status === 401 && !_retry) {
      const refreshTk = localStorage.getItem(CP_REFRESH_KEY);
      if (refreshTk && refreshTk !== 'undefined') {
        if (!_refreshing) {
          _refreshing = true;
          try {
            const newToken = await tryRefresh();
            if (newToken) {
              _refreshQueue.forEach((r) => r());
              _refreshQueue = [];
            } else {
              limpiarSesionCliente();
              window.dispatchEvent(new Event('cp:session-expired'));
              throw new Error('Sesión expirada. Por favor, inicia sesión nuevamente.');
            }
          } finally {
            _refreshing = false;
          }
        } else {
          await new Promise((resolve) => _refreshQueue.push(resolve));
        }
        return evidenciaApi.upload(files, true);
      }
      limpiarSesionCliente();
      window.dispatchEvent(new Event('cp:session-expired'));
      throw new Error('Sesión expirada. Por favor, inicia sesión nuevamente.');
    }

    let data;
    try { data = await res.json(); } catch { data = {}; }
    if (!res.ok) throw new Error(data?.message || 'Error al subir archivos');
    return data; // { urls: string[] }
  },
};

//  TIPOS CREDITO 
export const creditoApi = {
  getMisCreditos: (page = 1, limit = 10) =>
    request(`/portal-cliente/mis-creditos?page=${page}&limit=${limit}`),
  getCreditoDetalle: (id) => request(`/portal-cliente/mis-creditos/${id}`),

  getTipoCredito: (id = 1) => request(`/tipos-credito/${id}`),
  getDetalle: (id = 9)     => request(`/tipos-credito/detalles/${id}`),
  getRequisitos: (tipoId = 1) => request(`/tipos-credito/requisitos/tipo/${tipoId}`),
  getCondiciones: (detalleId = 9) =>
    request(`/tipos-credito/condiciones/all?detalle_tipo_credito_id=${detalleId}`),

  getInfoCompleta: async () => {
    const [tipo, detalle, requisitos, condiciones] = await Promise.all([
      request('/tipos-credito/1'),
      request('/tipos-credito/detalles/9'),
      request('/tipos-credito/requisitos/tipo/1'),
      request('/tipos-credito/condiciones/all?detalle_tipo_credito_id=9'),
    ]);
    return { tipo, detalle, requisitos, condiciones };
  },
};